import React, { useState, useRef, useEffect, useContext } from "react";
import "./UserRegister.css";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import { PathContext } from "../../App";
import { Button, Flex, Modal } from "antd";
import Meta from "../../components/Meta";
function UserRegister() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("login");
  const { path } = useContext(PathContext);
  const [agree, setAgree] = useState(false);
  const verifyRef = useRef(null);
  const registerRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [zipcode, setCode] = useState(null);
  const [phonenumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailForVerify, setEmailForVerify] = useState("");
  const [otp, setOtp] = useState("");
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");

  const [myError, setMyError] = useState("");
  const [myErrorDesc, setMyErrorDesc] = useState("");
  const [singInHeading, setHeading] = useState(
    "Welcome Back to Deal Direct Homes"
  );

  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (token && userId) {
      path === "nav"
        ? navigate("/user-auth/profile")
        : path === "tour"
          ? navigate("/schedule-tour")
          : path === "offer"
            ? navigate("/make-offer")
            : navigate("/");
    }
  }, [token]);
  const handleChangeTab = () => {
    switch (activeTab) {
      case "register":
        return setActiveTab("login");
      case "login":
        return setActiveTab("register");
      default:
        return setActiveTab("register");
    }
  };

  useEffect(() => {
    if (activeTab === "register") {
      if (verifyRef) {
        verifyRef.current.style.display = "none";
      }
    }
  }, [activeTab]);

  function loginValidation() {
    if (emailLogin.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (passwordLogin.length < 1) {
      toast.error("Password is required");
      return false;
    }

    return true;
  }
  function otpValidation() {
    if (otp.length < 1) {
      toast.error("OTP is required");
      return false;
    }
    if (!agree) {
      toast.error("You must agree first");
      return false;
    }

    return true;
  }
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  function validation() {
    if (name.length < 1) {
      // toast.error("Name is required");
      setMyErrorDesc("Name is required");
      setMyError("Name");

      return false;
    }

    if (email.length < 1) {
      // toast.error("Email is required");
      setMyErrorDesc("Email is required");
      setMyError("Email");
      return false;
    } else {
      if (!isValidEmail(email)) {
        setMyErrorDesc("Please enter valid email");
        // toast.error("Please enter valid email");
        setMyError("Email");
        return false;
      }
    }
    if (phonenumber.length < 1) {
      setMyErrorDesc("Phone number required");
      // toast.error("Phone number required");
      setMyError("Phone");
      return false;
    }
    if (phonenumber.length > 10) {
      setMyErrorDesc("Phone length should be under 11");
      // toast.error("Phone length should be under 11");
      setMyError("Phone");
      return false;
    }
    if (password.length < 1) {
      // toast.error("Password is required");
      setMyErrorDesc("Password is required");
      setMyError("Password");
      return false;
    }
    if (!agree) {
      // toast.error("You must agree first");
      toast("You must agree first", {
        type: "error",
        style: {
          background: "#252525",
          color: "#FF4C4C",
          borderLeft: "4px solid #FF4C4C",
        },
      });

      setMyErrorDesc("You must agree first");
      setMyError("");
      return false;
    }
    setMyErrorDesc("");
    setMyError("");

    return true;
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    //   if (window.fbq) {
    //   window.fbq('trackCustom', 'SignupButtonClick', {
    //     button: 'signup',
    //     source: 'landing_page', // Optional label
    //   });
    // }
    // if (typeof window.fbq !== "undefined") {
    //     console.log("fbq exists, sending event...");
    //     window.fbq('trackCustom', 'SignupButtonClick', {
    //       button: 'signup',
    //       source: 'landing_page',
    //     });
    //   } else {
    //     console.warn("Meta Pixel not loaded.");
    //   }

    const validate = await validation();

    if (validate) {
      const formData = new FormData();

      formData.append("name", name);
      formData.append("email", email);
      formData.append("phonenumber", phonenumber);
      formData.append("password", password);
      formData.append("zipcode", zipcode);
      setLoading(true);
      const toastLoading = await toast.loading("Creating new user...");
      try {
        const response = await fetch(`${API}/users/register-user`, {
          method: "POST",
          body: formData,
        });
        const json = await response.json();
        if (response.ok) {
      


            if (typeof window.fbq !== "undefined") {
        
            // REQUIRED: Track the successful registration (standard event)
            window.fbq('track', 'CompleteRegistration', {
              content_name: 'Client Registration',
              status: 'success',
          user_type: 'client_register', // or 'regular_user'
              method: 'email' // Could be 'facebook', 'google', etc.
            });
            
            console.log("Facebook Pixel events fired");
          } else {
            console.warn("Meta Pixel not loaded");
          }
          toast.dismiss(toastLoading);
          toast.success("Please check your email to verify your account");
          setLoading(false);
          // setEmailForVerify(json.data.email);

          // if (registerRef) {
          //   registerRef.current.style.display = "none";
          // }
          // if (verifyRef) {
          //   verifyRef.current.style.display = "block";
          // }
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("Once verified, you can login");
          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
        toast.dismiss(toastLoading);
      }
    }
  };
  const handleVerify = async (e) => {
    e.preventDefault();

    const validate = await otpValidation();

    if (validate) {
      const data = {
        email: emailForVerify,
        otp,
      };
      try {
        setLoading(true);
        const toastLoading = await toast.loading("OTP verifying...");
        const response = await fetch(`${API}/users/verify-otp`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("User verified successfully");
          setLoading(false);
          setName("");
          setEmail("");
          setPassword("");
          setPhoneNumber("");
          setOtp("");
          setHeading("You've created account, now login");
          handleChangeTab();
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const validate = await loginValidation();

    if (validate) {
      const data = {
        email: emailLogin,
        password: passwordLogin,
      };
      setLoading(true);
      const toastLoading = toast.loading("Signing in...");
      try {
        const response = await fetch(`${API}/users/login`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "Content-Type": "application/json",
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Signed in successfully");
          setLoading(false);

          await localStorage.removeItem("token");
          await localStorage.removeItem("laId");
          await localStorage.removeItem("laEmail");
          await localStorage.removeItem("laName");
          await localStorage.removeItem("laPhone");
          await localStorage.removeItem("laState");
          await localStorage.removeItem("token");
          await localStorage.removeItem("agentId");
          await localStorage.removeItem("agentEmail");
          await localStorage.removeItem("agentName");
          await localStorage.removeItem("agentPhone");

          await localStorage.removeItem("agentVendorType");
          await localStorage.removeItem("agentState");
          await localStorage.removeItem("agentZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("userId");
          await localStorage.removeItem("userEmail");
          await localStorage.removeItem("userName");
          await localStorage.removeItem("userPhone");
          await localStorage.removeItem("userZipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("advertiserId");
          await localStorage.removeItem("email");
          await localStorage.removeItem("name");
          await localStorage.removeItem("phone");
          await localStorage.removeItem("zipCode");

          await localStorage.removeItem("token");
          await localStorage.removeItem("adminId");
          await localStorage.removeItem("adminEmail");
          await localStorage.removeItem("adminName");
          await localStorage.removeItem("adminPhone");
          await localStorage.removeItem("token");
          await localStorage.removeItem("addhypeId");
          await localStorage.removeItem("addhypeEmail");
          await localStorage.removeItem("addhypeName");
          await localStorage.removeItem("addhypePhone");

          localStorage.setItem("token", json.data.token);
          localStorage.setItem("userId", json.data.user._id);
          localStorage.setItem("userEmail", json.data.user.email);
          localStorage.setItem("userName", json.data.user.name);
          localStorage.setItem("userPhone", json.data.user.phonenumber);
          localStorage.setItem("userZipCode", json.data.user.zipcode);
          path === "nav"
            ? navigate("/user-auth/profile")
            : path === "tour"
              ? navigate("/schedule-tour")
              : path === "offer"
                ? navigate("/make-offer")
                : navigate("/");
          setEmailLogin("");
          setPasswordLogin("");
        } else {
          console.log("else");
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.dismiss(toastLoading);
        toast.error(error.message);
      } finally {
        setLoading(false); // Only update loading state here
      }
    }
  };

  const [openResponsive, setOpenResponsive] = useState(false);

  const openTerms = () => {
    setOpenResponsive(true);
  };

  const handleForgot = (e) => {
    e.preventDefault();
    navigate("/forgot-password", { state: { type: "user" } });
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <Meta
        title="Sign Up for a Free Account | DDH"
        description="Create a free Deal Direct Homes account to save your favorite homes, get personalized recommendations, and more."
      />
      <div className="user-register-section">
        <NavbarComponent />
        {activeTab === "register" ? (
          <div className="container-fluid user-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 user-register-form-conatiner">
                <span ref={registerRef} className="w-100">
                  <h2 className="user-register-heading">
                    Join as a Deal Direct Member
                  </h2>
                  <div className="my-2">
                    <button
                      className="btn user-login-register-tab"
                      onClick={handleChangeTab}
                    >
                      Sign In
                    </button>
                    <button className="btn user-login-register-tab ms-3 active-user-login-register-tab">
                      Register
                    </button>
                  </div>
                  <form className="user-register-form">
                    <input
                      type="text"
                      className={`form-control user-register-input-field ${myError === "Name" ? "required-field" : ""}`}
                      id="exampleInputEmail1"
                      placeholder="Full Name"
                      aria-describedby="emailHelp"
                      onChange={(e) => setName(e.target.value)}
                    />
                    {myError === "Name" && (
                      <small style={{ color: "#d4bb98" }}>
                        * {myErrorDesc}
                      </small>
                    )}

                    <input
                      type="email"
                      className={`form-control user-register-input-field ${myError === "Email" ? "required-field" : ""}`}
                      id="exampleInputPassword1"
                      placeholder="Email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    {myError === "Email" && (
                      <small style={{ color: "#d4bb98" }}>
                        * {myErrorDesc}
                      </small>
                    )}
                    {isMobile ? (
                      <>
                        <input
                          type="tel"
                          className={`form-control user-register-input-field ${myError === "Phone" ? "required-field" : ""}`}
                          id="userPhone"
                          placeholder="Phone number"
                          value={`+1 ${phonenumber}`} // Display "+1" prefix
                          onChange={(e) => {
                            // Remove "+1" and any extra spaces before saving to state
                            const rawNumber = e.target.value
                              .replace(/^\+1\s*/, "")
                              .slice(0, 10);
                            setPhoneNumber(rawNumber);
                          }}
                        />
                        {myError === "Phone" && (
                          <small style={{ color: "#d4bb98" }}>
                            * {myErrorDesc}
                          </small>
                        )}
                      </>
                    ) : (
                      <>
                        <div className={`user-register-phone-number-group`}>
                          <button disabled className="user-register-phone-code">
                            +1
                          </button>
                          <input
                            type="number"
                            className={`form-control user-register-phone-field ${myError === "Phone" ? "required-field" : ""}`}
                            id="exampleInputPassword1"
                            placeholder="Phone Number"
                            maxLength="10"
                            min="0"
                            max="9999999999"
                            pattern="\d*"
                            onChange={(e) => {
                              const value = e.target.value
                                .replace(/\D/g, "")
                                .slice(0, 10);
                              setPhoneNumber(value);
                              e.target.value = value;
                            }}
                          />
                          {myError === "Phone" && (
                            <small style={{ color: "#d4bb98" }}>
                              * {myErrorDesc}
                            </small>
                          )}
                        </div>
                      </>
                    )}
                    {myError === "Phone" && <hr style={{ opacity: 0 }} />}

                    <input
                      type="password"
                      className={`form-control user-register-input-field ${isMobile ? "" : "pass-input"} ${myError === "Password" ? "required-field" : ""}`}
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {myError === "Password" && (
                      <small style={{ color: "#d4bb98" }}>
                        * {myErrorDesc}
                      </small>
                    )}
                    <div className="mb-3 form-check user-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid d-flex justify-content-end pb-3">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                        </div>
                        <div className="container-fluid pop-up-terms">
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Deal Direct Homes Privacy Policy
                                </h2>
                                <p className="agreement-paragraph">
                                  In no event will Deal Direct Homes Inc. be
                                  liable for any loss or damage including,
                                  without limitation, indirect or consequential
                                  loss or damage, or any loss or damage
                                  whatsoever arising from loss out of, or in
                                  connection with, the use of this website.
                                </p>
                              </div>
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Terms of Use
                                </h2>
                                <p className="agreement-paragraph">
                                  Welcome and thank you for your interest in
                                  Deal Direct Homes Inc (DDH). By clicking a any
                                  new account submission button, or by otherwise
                                  using our websites, mobile applications, or
                                  other services provided by DDH (collectively,
                                  the “Services”), or accessing any content
                                  provided by us through the Services, you agree
                                  to be bound by the following terms of use, as
                                  updated from time to time (the “Terms of
                                  Use”). <br /> <br />
                                  <ol>
                                    <li>
                                      {" "}
                                      <span className="agreement-paragraph-list-heading">
                                        DDH Affiliate Companies’ Role.
                                      </span>{" "}
                                      DDH, Affiliates, and or Service providers,
                                      may assist you in performing the various
                                      tasks in a real estate transaction.
                                      However, unless explicitly specified, DDH
                                      or SERVICES ARE NOT INTENDED TO provide
                                      you with any financial, real estate, or
                                      related advice of any kind. You understand
                                      and agree that the Services may include
                                      advertisements. To help make the
                                      advertisements relevant and useful to you,
                                      DDH Affiliates may create and distribute
                                      advertisements based on the information we
                                      collect through ours or other Services.
                                      See our Privacy Policy for more details
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        DDH is Not a Lender or Real Estate
                                        Company.
                                      </span>{" "}
                                      DDH does not provide or utilize any
                                      information for use in loan-related
                                      decisions, and you acknowledge and agree
                                      not to use any information obtained from
                                      DDH or any other DDH Affiliate Companies’
                                      Services for loan-related excisions. If
                                      you choose to engage with Loan Service
                                      provider, Or Real Estate Services you will
                                      be subject to that separate Providers
                                      Product’s or Service Terms.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Generally.
                                      </span>{" "}
                                      The Services include links to third-party
                                      products, services, and websites, as well
                                      as materials provided by third parties,
                                      and may include functionality that allows
                                      for the distribution of your User
                                      Materials or your personal information
                                      (collectively, your “User Information”) to
                                      third parties not under our control (each,
                                      a “Third-Party Provider”). Third-Party
                                      Providers are solely responsible for their
                                      services. You are responsible for your use
                                      and submission of User Information to any
                                      third party, and your dealings or business
                                      conducted with any third party arising in
                                      connection with the Services are solely
                                      between you and such third party. Your use
                                      of third-party sites, services, or
                                      products may be subject to associated
                                      third-party terms of use and privacy
                                      policies or other agreements, which you
                                      are solely responsible for complying with.
                                      We do not endorse, and take no
                                      responsibility for such products,
                                      services, Web sites, and materials, or a
                                      Third-Party Provider’s use of your User
                                      Information. By using a tool that allows
                                      for User Information to be transferred,
                                      you agree that we may transfer the
                                      applicable User Information or other
                                      information to the applicable third
                                      parties, which are not under our control.
                                      If you submit a contact form or otherwise
                                      indicate your interest in contacting a
                                      Third-Party Provider, you may receive
                                      telemarketing calls from the Third-Party
                                      Provider using the contact information you
                                      provided. Third-Party Providers may keep
                                      your contact information and any other
                                      information received by the Third-Party
                                      Provider in processing a contact or other
                                      request form. We are not responsible for
                                      any damage or costs of any type arising
                                      out of or in any way connected with your
                                      dealings with these third parties.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Advertisers and Vendors (AV).
                                      </span>{" "}
                                      All the AV Services that DDH may or may
                                      not recommend are completely independent
                                      and NOT a part of DDH. DDH does not
                                      control nor monitor said services and must
                                      be held harmless for and from any
                                      liability using said services.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        You may Not.
                                      </span>{" "}
                                      BY USING THE SERVICES, YOU AGREE NOT TO:
                                      <ul>
                                        <li className="mt-2">
                                          reproduce, modify, distribute, display
                                          or otherwise provide access to, create
                                          derivative works from, decompile,
                                          disassemble, or reverse engineer any
                                          portion of the Services, except as
                                          explicitly permitted by any Product’s
                                          Terms to the extent applicable to that
                                          product’s Services.
                                          <li className="mt-1">
                                            provide/post/authorize a link to any
                                            of the Services from a third-party
                                            website that is not a real
                                            estate-related website owned or
                                            operated by a real estate or lending
                                            professional or institution.
                                          </li>
                                          <li className="mt-1">
                                            remove or modify any copyright or
                                            other intellectual property notices
                                            that appear in the Services.
                                          </li>
                                          <li className="mt-1">
                                            use the Services in any way that is
                                            unlawful, or harms DDH, its service
                                            providers, suppliers, affiliates, or
                                            any other user.
                                          </li>
                                          <li className="mt-1">
                                            use DDH Services to discriminate
                                            against any individual or class of
                                            individuals protected under federal,
                                            state or local laws, or which may
                                            have a discriminatory impact against
                                            any individual or class of
                                            individuals, or which otherwise
                                            promotes illegal, racist or
                                            discriminatory activities or
                                            outcomes.
                                          </li>
                                          <li className="mt-1">
                                            impersonate another person,
                                            misrepresent your affiliation with
                                            another person or entity, or make
                                            any representation to any third
                                            party under false pretenses.
                                          </li>
                                          <li className="mt-1">
                                            upload invalid data, viruses, worms,
                                            or other software agents to any DDH
                                            websites or the like.
                                          </li>
                                          <li className="mt-1">
                                            use any of the DDH trademarks as
                                            part of your screen name or email
                                            address.
                                          </li>
                                          <li className="mt-1">
                                            access or use any of the Services to
                                            develop competitive products or
                                            services; or
                                          </li>
                                          <li className="mt-1">
                                            attempt to, or permit or encourage
                                            any third party to, do any of the
                                            above.
                                          </li>
                                        </li>
                                      </ul>
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Fees
                                      </span>{" "}
                                      <ol>
                                        <li className="mt-2">
                                          <span className="agreement-paragraph-list-heading">
                                            Payment to Services or DDH.
                                          </span>{" "}
                                          You may be required to pay fees to
                                          access certain Services Providers,
                                          those fees are not a part of DDH and
                                          are paid directly to the Service
                                          Provider. All fees are in U.S. dollars
                                          and paid directly to the Service
                                          provider. DDH uses an authorized
                                          third-party payment processor and will
                                          charge the payment method you
                                          specified at the time of purchase or
                                          as agreed to as part of the Lead
                                          Purchase. You authorize DDH to charge
                                          all fees as described in the Service
                                          Provider AV Agreement you selected and
                                          provided payment method and
                                          information.
                                        </li>
                                        <li className="mt-2">
                                          <span className="agreement-paragraph-list-heading">
                                            Hold Harmless.
                                          </span>{" "}
                                          You agree to indemnify, defend, and
                                          hold harmless DDH, our affiliates,
                                          Service providers and our respective
                                          directors, officers, employees, and
                                          agents from any and all claims and
                                          demands made by any third party due to
                                          or arising out of: (a) your access to
                                          or use of the Services; (b) your
                                          breach of these Terms of Use; (c) your
                                          violation of any law or the rights of
                                          a third party; (d) any dispute or
                                          issue between you and any third party;
                                          (e) any User Materials you upload to,
                                          or otherwise make available through,
                                          the Services; (f) your willful
                                          misconduct; and (g) any other party’s
                                          access to or use of the Services using
                                          your account and password. DDH
                                          reserves the right, at their own
                                          expense, to assume the exclusive
                                          defense and control of any matter
                                          otherwise subject to indemnification
                                          by you, and in that case, you agree to
                                          cooperate with DDH’s defense of that
                                          claim.
                                        </li>
                                      </ol>
                                    </li>
                                  </ol>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn user-register-button">
                        Processing...
                      </span>
                    ) : (
                      <button
                        onClick={handleSignUp}
                        className="btn user-register-button"
                      >
                        Sign Up
                      </button>
                    )}

                    {/* <img
                    src="/img/user-register-devider.svg"
                    className="img-fluid user-register-devider"
                    alt=""
                  />
                  <button
                    type="button"
                    className="btn user-register-google-button"
                  >
                    <img src="/img/google.png" alt="" /> Continue with Google
                  </button> */}
                  </form>
                </span>
                <span ref={verifyRef} className="w-100">
                  <h2 className="user-register-heading code-veri-heading">
                    Verify Account
                  </h2>

                  <form className="user-register-form code-veri-input">
                    <input
                      type="number"
                      className="form-control user-register-input-field"
                      id="exampleInputEmail1"
                      placeholder="00 00"
                      aria-describedby="emailHelp"
                      onChange={(e) => setOtp(e.target.value)}
                    />

                    <label style={{ opacity: "0.8" }} className="code-label">
                      4 - Digit code has been sent to your phone number and
                      email.{" "}
                      {/* <Link className="text-white">Change Details</Link>s */}
                    </label>

                    <label className="code-label" style={{ opacity: "0.7" }}>
                      By using Deal Direct Homes (DDH), you agree to these terms
                      and conditions. If you do not agree, please refrain from
                      using our services. DDH provides property listings and
                      connects users with licensed real estate agents but does
                      not directly buy, sell, or broker real estate
                      transactions. While we strive to ensure the accuracy and
                      timeliness of information on our platform, we cannot
                      guarantee its completeness.
                    </label>

                    <div className="mb-3 form-check user-register-verify-check-group px-0">
                      <img
                        role="button"
                        onClick={() => setAgree(!agree)}
                        src={`${agree ? "/img/checked.svg" : "/img/uncheck.svg"}`}
                        className="img-fluid"
                        alt=""
                      />

                      <label
                        className="form-check-label ms-3"
                        htmlFor="exampleCheck1"
                      >
                        I agree to the{" "}
                        <b
                          className="text-white"
                          onClick={openTerms}
                          role="button"
                        >
                          Terms and Conditions
                        </b>{" "}
                        set by DDH
                      </label>
                      <Modal
                        style={{ padding: "0px", margin: "0px" }}
                        centered
                        open={openResponsive}
                        footer={null}
                        closable={false}
                        width={{
                          xs: "90%",
                          sm: "80%",
                          md: "65%",
                          lg: "60%",
                          xl: "60%",
                          xxl: "60%",
                        }}
                      >
                        <div className="container-fluid d-flex justify-content-end pb-3">
                          <img
                            src="/img/pop-up-close.svg"
                            className="img-fluid"
                            onClick={() => setOpenResponsive(false)}
                            role="button"
                            alt=""
                          />
                        </div>
                        <div className="container-fluid pop-up-terms">
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Deal Direct Homes Privacy Policy
                                </h2>
                                <p className="agreement-paragraph">
                                  In no event will Deal Direct Homes Inc. be
                                  liable for any loss or damage including,
                                  without limitation, indirect or consequential
                                  loss or damage, or any loss or damage
                                  whatsoever arising from loss out of, or in
                                  connection with, the use of this website.
                                </p>
                              </div>
                              <div className="col-12 agreement-1st-container">
                                <h2 className="agreement-heading">
                                  Terms of Use
                                </h2>
                                <p className="agreement-paragraph">
                                  Welcome and thank you for your interest in
                                  Deal Direct Homes Inc (DDH). By clicking a any
                                  new account submission button, or by otherwise
                                  using our websites, mobile applications, or
                                  other services provided by DDH (collectively,
                                  the “Services”), or accessing any content
                                  provided by us through the Services, you agree
                                  to be bound by the following terms of use, as
                                  updated from time to time (the “Terms of
                                  Use”). <br /> <br />
                                  <ol>
                                    <li>
                                      {" "}
                                      <span className="agreement-paragraph-list-heading">
                                        DDH Affiliate Companies’ Role.
                                      </span>{" "}
                                      DDH, Affiliates, and or Service providers,
                                      may assist you in performing the various
                                      tasks in a real estate transaction.
                                      However, unless explicitly specified, DDH
                                      or SERVICES ARE NOT INTENDED TO provide
                                      you with any financial, real estate, or
                                      related advice of any kind. You understand
                                      and agree that the Services may include
                                      advertisements. To help make the
                                      advertisements relevant and useful to you,
                                      DDH Affiliates may create and distribute
                                      advertisements based on the information we
                                      collect through ours or other Services.
                                      See our Privacy Policy for more details
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        DDH is Not a Lender or Real Estate
                                        Company.
                                      </span>{" "}
                                      DDH does not provide or utilize any
                                      information for use in loan-related
                                      decisions, and you acknowledge and agree
                                      not to use any information obtained from
                                      DDH or any other DDH Affiliate Companies’
                                      Services for loan-related excisions. If
                                      you choose to engage with Loan Service
                                      provider, Or Real Estate Services you will
                                      be subject to that separate Providers
                                      Product’s or Service Terms.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Generally.
                                      </span>{" "}
                                      The Services include links to third-party
                                      products, services, and websites, as well
                                      as materials provided by third parties,
                                      and may include functionality that allows
                                      for the distribution of your User
                                      Materials or your personal information
                                      (collectively, your “User Information”) to
                                      third parties not under our control (each,
                                      a “Third-Party Provider”). Third-Party
                                      Providers are solely responsible for their
                                      services. You are responsible for your use
                                      and submission of User Information to any
                                      third party, and your dealings or business
                                      conducted with any third party arising in
                                      connection with the Services are solely
                                      between you and such third party. Your use
                                      of third-party sites, services, or
                                      products may be subject to associated
                                      third-party terms of use and privacy
                                      policies or other agreements, which you
                                      are solely responsible for complying with.
                                      We do not endorse, and take no
                                      responsibility for such products,
                                      services, Web sites, and materials, or a
                                      Third-Party Provider’s use of your User
                                      Information. By using a tool that allows
                                      for User Information to be transferred,
                                      you agree that we may transfer the
                                      applicable User Information or other
                                      information to the applicable third
                                      parties, which are not under our control.
                                      If you submit a contact form or otherwise
                                      indicate your interest in contacting a
                                      Third-Party Provider, you may receive
                                      telemarketing calls from the Third-Party
                                      Provider using the contact information you
                                      provided. Third-Party Providers may keep
                                      your contact information and any other
                                      information received by the Third-Party
                                      Provider in processing a contact or other
                                      request form. We are not responsible for
                                      any damage or costs of any type arising
                                      out of or in any way connected with your
                                      dealings with these third parties.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Advertisers and Vendors (AV).
                                      </span>{" "}
                                      All the AV Services that DDH may or may
                                      not recommend are completely independent
                                      and NOT a part of DDH. DDH does not
                                      control nor monitor said services and must
                                      be held harmless for and from any
                                      liability using said services.
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        You may Not.
                                      </span>{" "}
                                      BY USING THE SERVICES, YOU AGREE NOT TO:
                                      <ul>
                                        <li className="mt-2">
                                          reproduce, modify, distribute, display
                                          or otherwise provide access to, create
                                          derivative works from, decompile,
                                          disassemble, or reverse engineer any
                                          portion of the Services, except as
                                          explicitly permitted by any Product’s
                                          Terms to the extent applicable to that
                                          product’s Services.
                                          <li className="mt-1">
                                            provide/post/authorize a link to any
                                            of the Services from a third-party
                                            website that is not a real
                                            estate-related website owned or
                                            operated by a real estate or lending
                                            professional or institution.
                                          </li>
                                          <li className="mt-1">
                                            remove or modify any copyright or
                                            other intellectual property notices
                                            that appear in the Services.
                                          </li>
                                          <li className="mt-1">
                                            use the Services in any way that is
                                            unlawful, or harms DDH, its service
                                            providers, suppliers, affiliates, or
                                            any other user.
                                          </li>
                                          <li className="mt-1">
                                            use DDH Services to discriminate
                                            against any individual or class of
                                            individuals protected under federal,
                                            state or local laws, or which may
                                            have a discriminatory impact against
                                            any individual or class of
                                            individuals, or which otherwise
                                            promotes illegal, racist or
                                            discriminatory activities or
                                            outcomes.
                                          </li>
                                          <li className="mt-1">
                                            impersonate another person,
                                            misrepresent your affiliation with
                                            another person or entity, or make
                                            any representation to any third
                                            party under false pretenses.
                                          </li>
                                          <li className="mt-1">
                                            upload invalid data, viruses, worms,
                                            or other software agents to any DDH
                                            websites or the like.
                                          </li>
                                          <li className="mt-1">
                                            use any of the DDH trademarks as
                                            part of your screen name or email
                                            address.
                                          </li>
                                          <li className="mt-1">
                                            access or use any of the Services to
                                            develop competitive products or
                                            services; or
                                          </li>
                                          <li className="mt-1">
                                            attempt to, or permit or encourage
                                            any third party to, do any of the
                                            above.
                                          </li>
                                        </li>
                                      </ul>
                                    </li>
                                    <li className="mt-2">
                                      <span className="agreement-paragraph-list-heading">
                                        Fees
                                      </span>{" "}
                                      <ol>
                                        <li className="mt-2">
                                          <span className="agreement-paragraph-list-heading">
                                            Payment to Services or DDH.
                                          </span>{" "}
                                          You may be required to pay fees to
                                          access certain Services Providers,
                                          those fees are not a part of DDH and
                                          are paid directly to the Service
                                          Provider. All fees are in U.S. dollars
                                          and paid directly to the Service
                                          provider. DDH uses an authorized
                                          third-party payment processor and will
                                          charge the payment method you
                                          specified at the time of purchase or
                                          as agreed to as part of the Lead
                                          Purchase. You authorize DDH to charge
                                          all fees as described in the Service
                                          Provider AV Agreement you selected and
                                          provided payment method and
                                          information.
                                        </li>
                                        <li className="mt-2">
                                          <span className="agreement-paragraph-list-heading">
                                            Hold Harmless.
                                          </span>{" "}
                                          You agree to indemnify, defend, and
                                          hold harmless DDH, our affiliates,
                                          Service providers and our respective
                                          directors, officers, employees, and
                                          agents from any and all claims and
                                          demands made by any third party due to
                                          or arising out of: (a) your access to
                                          or use of the Services; (b) your
                                          breach of these Terms of Use; (c) your
                                          violation of any law or the rights of
                                          a third party; (d) any dispute or
                                          issue between you and any third party;
                                          (e) any User Materials you upload to,
                                          or otherwise make available through,
                                          the Services; (f) your willful
                                          misconduct; and (g) any other party’s
                                          access to or use of the Services using
                                          your account and password. DDH
                                          reserves the right, at their own
                                          expense, to assume the exclusive
                                          defense and control of any matter
                                          otherwise subject to indemnification
                                          by you, and in that case, you agree to
                                          cooperate with DDH’s defense of that
                                          claim.
                                        </li>
                                      </ol>
                                    </li>
                                  </ol>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                    {loading ? (
                      <span className="btn veri-button">Verifying...</span>
                    ) : (
                      <button
                        onClick={handleVerify}
                        className="btn veri-button"
                      >
                        Verify
                      </button>
                    )}
                  </form>
                </span>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="user-register-image-conatiner"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid user-register-container px-0">
            <div className="row px-0 mx-0">
              <div className="col-lg-6 user-register-form-conatiner">
                <h2 className="user-register-heading">{singInHeading}</h2>
                <div className="my-2">
                  <button className="btn user-login-register-tab active-user-login-register-tab">
                    Sign In
                  </button>
                  <button
                    className="btn user-login-register-tab ms-3"
                    onClick={handleChangeTab}
                  >
                    Register
                  </button>
                </div>
                <form className="user-register-form">
                  <input
                    type="email"
                    className="form-control user-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Email"
                    onChange={(e) => setEmailLogin(e.target.value)}
                    value={emailLogin}
                  />

                  <input
                    type="password"
                    className="form-control user-register-input-field"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    onChange={(e) => setPasswordLogin(e.target.value)}
                    value={passwordLogin}
                  />
                  <p
                    onClick={handleForgot}
                    style={{ cursor: "pointer", lineHeight: "1px" }}
                    className="forgot-password-button mt-4"
                  >
                    Forgot Password?
                  </p>
                  <button
                    onClick={handleLogin}
                    className="btn user-register-button"
                  >
                    Sign In
                  </button>
                  {/* <img
                  src="/img/user-register-devider.svg"
                  className="img-fluid user-register-devider"
                  alt=""
                />
                <button
                  type="button"
                  className="btn user-register-google-button"
                >
                  <img src="/img/google.png" alt="" /> Continue with Google
                </button> */}
                </form>
              </div>
              <div className="col-lg-6 px-0 d-none d-lg-block">
                <div className="user-signin-image-conatiner"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default UserRegister;
